<template>
  <v-dialog v-model="internalVisible" max-width="500px">
    <v-card class="dialog-wrapper">
      <v-card-title class="dialog-title">
        {{ $t("Confirm Delete") }}
      </v-card-title>

      <v-card-text class="dialog-text">
        {{ $t("Are you sure you want to delete this group?") }}
      </v-card-text>

      <v-card-actions class="dialog-actions">
        <v-spacer />
        <v-btn text class="cancel-button" @click="close(false)">
          <v-icon left small>mdi-close</v-icon>
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn class="modern-button modern-danger" @click="close(true)">
          <v-icon left small>mdi-check</v-icon>
          {{ $t("Delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GroupDeleteDialog',
  data() {
    return {
      internalVisible: false,
      resolve: null
    };
  },
  methods: {
    open() {
      this.internalVisible = true;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    close(result) {
      this.internalVisible = false;
      if (this.resolve) this.resolve(result);
    }
  }
};
</script>

<style scoped lang="scss">
.dialog-wrapper {
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  background: #fff;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.dialog-title {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.dialog-text {
  font-size: 16px;
  padding: 12px 0;
  color: #333;
}

.dialog-actions {
  padding-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-button {
  color: #555;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.modern-button {
  text-transform: none;
  border-radius: 8px;
  padding: 8px 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.modern-danger {
  background: linear-gradient(90deg, #c62828, #ef5350);
  color: #fff;
}

/* ═══════════════════════════════════════
   DARK THEME OVERRIDES
   ═══════════════════════════════════════ */

.theme--dark .dialog-wrapper {
  background: rgba(26, 27, 35, 0.85) !important;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid #2a2c3a;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.theme--dark .dialog-title {
  color: #e4e5eb;
}

.theme--dark .dialog-text {
  color: #b0b2be;
}

.theme--dark .cancel-button {
  color: #8b8d9e;
}

.theme--dark .modern-danger {
  background: linear-gradient(90deg, #c62828, #ef5350);
  box-shadow: 0 4px 14px rgba(198, 40, 40, 0.25);
}
</style>
